import React, { useEffect, useState } from "react";
import LoadingModal from "../../components/shared/LoadingModal";
import AuthLayout from "../../layouts/AuthLayout";
import { getNonLoggedInContent, getKalekimOrganizations, getKaleseramikOrganizations } from "../../services/contentService";
import classNames from "classnames";
import Parse from "parse";
import KalekimTab from "../Library/components/KalekimTab";
import KaleseramikTab from "../Library/components/KaleseramikTab";

const AboutUsPage = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [kalekimOrganizations, setKalekimOrganizations] = useState([]);
  const [kaleseramikOrganizations, setKaleseramikOrganizations] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await getNonLoggedInContent();
        setContent(result);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await getKalekimOrganizations();
        setKalekimOrganizations(result);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const result = await getKaleseramikOrganizations();
        setKaleseramikOrganizations(result);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    // Get currentUser from Parse
    const user = Parse.User.current();
    if (user) {
      setCurrentUser(user.toJSON());
    }
  }, []);

  const hasAnyOrganizations =
    (Array.isArray(kalekimOrganizations) && kalekimOrganizations.length > 0) ||
    (Array.isArray(kaleseramikOrganizations) && kaleseramikOrganizations.length > 0);

  const activeTabMarkup = () => {
    switch (activeTab) {
      case 1:
        return <KalekimTab organizations={kalekimOrganizations} type="organization" />;
      case 2:
        return <KaleseramikTab organizations={kaleseramikOrganizations} type="organization" />;
      default:
        return;
    }
  };

  return (
    <>
      <AuthLayout>
        {loading && <LoadingModal />}
        <div id="content">
          <div className="px-4 py-5 bg-background-teal md:px-4 lg:py-16 lg:px-0">
            <main className="px-4 mx-auto max-w-7xl lg:px-1">
              <div className="flex flex-col justify-between grid-cols-12 p-4 space-y-4 lg:p-0 lg:grid lg:flex-row lg:items-center sm:space-y-0">
                <h1
                  className="col-span-7 text-md lg:text-xxl text-primary-black font-lg lg:mb-0"
                  data-testid="about-us-header"
                >
                  Kale Hakkında
                </h1>
                <h6 className="col-span-5">{content?.about_kale_subtitle}</h6>
              </div>
            </main>
          </div>
          <div className="px-4 mx-auto my-12 max-w-7xl lg:my-16 xl:px-1">
            <div className="flex flex-col justify-between xl:flex-row">
              <div className="flex flex-1 lg:px-16">
                <img
                  src={content?.about_kale_image?.url}
                  alt=""
                  className="w-full"
                  data-testid="about-us-image"
                />
              </div>
              <div className="flex flex-col flex-1 pt-5">
                <h2 className="text-xl">{content?.about_kale_title}</h2>
                <p
                  className="mt-8 text-body-s text-justify text-secondary-primary"
                  data-testid="about-us-text"
                >
                  {content?.about_kale_text}
                </p>
              </div>
            </div>
          </div>

          <div className="py-16 mb-2 bg-secondary-secondary-bg">
            <div className="px-1 mx-auto max-w-7xl">
              <div className="flex flex-col px-4 lg:px-0">
                <h2 className="text-lg text-center lg:text-xl">Değerlerimiz</h2>
                <div className="flex flex-col justify-between gap-16 mt-20 lg:flex-row lg:gap-0">
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full">
                      <img
                        src="/assets/img/about-us/trust.jpg"
                        alt="we create trust"
                      />
                    </span>
                    <h6 className="text-xs font-sm">Güven Yaratırız</h6>
                  </div>
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full">
                      <img
                        alt="we are committed"
                        src="/assets/img/about-us/committed.jpg"
                      />
                    </span>
                    <h6 className="text-xs font-sm">
                      Kararlı ve Azimli Davranırız
                    </h6>
                  </div>
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full">
                      <img
                        src="/assets/img/about-us/responsibility.jpg"
                        alt="we take responsibility"
                      />
                    </span>
                    <h6 className="text-xs font-sm">Sorumluluk Alırız</h6>
                  </div>
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full">
                      <img
                        src="/assets/img/about-us/partnership.jpg"
                        alt="we act in partnership"
                      />
                    </span>
                    <h6 className="text-xs font-sm">
                      İş Birliği İçinde <br /> Hareket Ederiz
                    </h6>
                  </div>
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full">
                      <img src="/assets/img/about-us/lead.jpg" alt="we lead" />
                    </span>
                    <h6 className="text-xs font-sm">Öncülük Ederiz</h6>
                  </div>
                  <div className="flex flex-col items-center gap-6">
                    <span className="flex items-center justify-center w-32 h-32 rounded-full bg-primary-yellow">
                      <img
                        src="/assets/img/about-us/entrepreneurship.jpg"
                        alt="we support entrepreneurship"
                      />
                    </span>
                    <h6 className="text-xs font-sm">
                      Girişimciliği Destekleriz
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {hasAnyOrganizations && (
            <div className="bg-white">
              <div className="max-w-5xl mx-auto">
                <div className="py-16">
                  <h2 className="mb-16 text-xl text-center">Organizasyonlar</h2>
                  <div className="mb-12 text-center">
                    <div className="relative z-0 inline-flex bg-secondary-secondary-bg mx-auto p-0.5">
                      {currentUser?.siteId === "bayi" &&
                        <>
                          <button
                            data-testid="organization-tab-1"
                            type="button"
                            onClick={() => setActiveTab(1)}
                            className={classNames(
                              activeTab === 1
                                ? "inline-block !bg-primary-red !text-white active"
                                : "inline-block !text-primary-black !bg-transparent",
                              "px-4 tab-btn text-primary-black hover:text-white lg:w-48"
                            )}
                          >
                            Kalekim
                          </button>
                          <button
                            data-testid="organization-tab-2"
                            type="button"
                            onClick={() => setActiveTab(2)}
                            className={classNames(
                              activeTab === 2
                                ? "inline-block !bg-primary-red !text-white active"
                                : "inline-block !text-primary-black !bg-transparent",
                              "px-4 tab-btn text-primary-black hover:text-white lg:w-48"
                            )}
                          >
                            Kaleseramik
                          </button>
                        </>
                      }
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-10 px-4 lg:grid-cols-3 lg:px-0"></div>
                  {activeTabMarkup()}
                </div>
              </div>
            </div>
          )}
        </div>
      </AuthLayout>
    </>
  );
};

export default AboutUsPage;
